import type { HTMLProps } from 'react'
import type { RuleSet } from 'styled-components'
import * as Dialog from '@radix-ui/react-dialog'
import * as Popover from '@radix-ui/react-popover'
import { mqMin, space, tok, tokPx, withStyleModifiers } from '@sunwebgroup/ui-components'
import { Button } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

import { css, styled } from 'styled-components'

import { DropdownMultiselectContext } from './context'

const Wrapper = styled.div`
  display:flex;
  position: sticky;
  padding: ${space('primitives_space_12')};

  position: -webkit-sticky;
  bottom: 0;
  background-color: ${tok('semantics_views_background_color')};
  z-index: 1;
  padding: ${space('primitives_space_12')} ${space('primitives_space_16')};
  border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};
  }

`

function ConfirmButton({ children, className }: HTMLProps<HTMLButtonElement>) {
  const { asDialog } = React.use(DropdownMultiselectContext)
  const content = <Button fullWidth>{children}</Button>
  return (
    <Wrapper className={className}>
      {asDialog && <Dialog.Close asChild>{content}</Dialog.Close>}
      {!asDialog && <Popover.Close asChild>{content}</Popover.Close>}
    </Wrapper>
  )
}

function modNoShadow(): RuleSet<object> {
  return css`
    padding: 0;
    box-shadow: none;
  `
}

export default withStyleModifiers(styled(ConfirmButton)``, {
  modNoShadow,
})
